module.exports = __webpack_public_path__ + "static/media/5f8de7ed5ae7590275f0750b_logo_200x200.5d4bf48a.png";